export default __webpack_public_path__ + "static/media/show-logo.04f9cb57.svg";